import React from 'react';
import {
  ROLE_COMPONENT_IDS,
  getCachedUserRole,
  getEffectiveUserRole,
  setViewAsRole,
} from '../../../services/auth.service';
import './RoleViewTabs.css';

const ROLE_TABS = [
  { id: ROLE_COMPONENT_IDS.ADMIN, label: 'Admin' },
  { id: ROLE_COMPONENT_IDS.MANAGER, label: 'Manager' },
  { id: ROLE_COMPONENT_IDS.IDEA_OWNER, label: 'Idea Owner' },
];

function RoleViewTabs({ onChange }) {
  const actualRole = getCachedUserRole();
  const effectiveRole = getEffectiveUserRole();

  // Role switcher is intentionally admin-only for development/testing preview.
  if (actualRole !== ROLE_COMPONENT_IDS.ADMIN) return null;

  const handleClick = (role) => {
    setViewAsRole(role);
    if (onChange) onChange(role);
  };

  return (
    <div className="role-view-tabs" role="tablist" aria-label="View as role">
      {ROLE_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`role-view-tab ${effectiveRole === tab.id ? 'active' : ''}`}
          onClick={() => handleClick(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default RoleViewTabs;
